import BlockModel from '@wre/infinity-generators/SchemeOfLearning/Year6/Autumn/FractionsA/index';
import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'FractionsA',
  field: 'Number',
  weeks: [8, 9],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      ...BlockModel.smallSteps[0],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Autumn/FractionsA/1EquivalentFractionsAndSimplifying" */ './1EquivalentFractionsAndSimplifying'
        )
    }),
    // Step 2
    newSmallStepContent({
      ...BlockModel.smallSteps[1],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Autumn/FractionsA/2EquivalentFractionsOnANumberLine" */ './2EquivalentFractionsOnANumberLine'
        )
    }),
    // Step 3
    newSmallStepContent({
      ...BlockModel.smallSteps[2],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Autumn/FractionsA/3CompareAndOrderDenominator" */ './3CompareAndOrderDenominator'
        )
    }),
    // Step 4
    newSmallStepContent({
      ...BlockModel.smallSteps[3],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Autumn/FractionsA/4CompareAndOrderNumerator" */ './4CompareAndOrderNumerator'
        )
    }),
    // Step 5
    newSmallStepContent({
      ...BlockModel.smallSteps[4],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Autumn/FractionsA/5AddAndSubtractSimpleFractions" */ './5AddAndSubtractSimpleFractions'
        )
    }),
    // Step 6
    newSmallStepContent({
      ...BlockModel.smallSteps[5],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Autumn/FractionsA/6AddAndSubtractAnyTwoFractions" */ './6AddAndSubtractAnyTwoFractions'
        )
    }),
    // Step 7
    newSmallStepContent({
      ...BlockModel.smallSteps[6],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Autumn/FractionsA/7AddMixedNumbers" */ './7AddMixedNumbers'
        )
    }),
    // Step 8
    newSmallStepContent({
      ...BlockModel.smallSteps[7],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Autumn/FractionsA/8SubtractMixedNumbers" */ './8SubtractMixedNumbers'
        )
    }),
    // Step 9
    newSmallStepContent({
      ...BlockModel.smallSteps[8],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Autumn/FractionsA/9MultiStepProblems" */ './9MultiStepProblems'
        )
    })
  ]
});
export default Block;
